<template lang="pug">
  #CustomerTempModel.CustomerModel.CustomerModel-tempModel.overflow-hidden(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .content-header.modal_header.rounded-bottom-1rem.pt-0(
      style="height: 50px;"
    )
      .row.align-items-center.h-100
        .col-10
          h5.mb-0 {{ title }}
        .col-2.d-flex.align-items-center.justify-content-center
          i.iconClose(
            @click="closeModel()"
          )
    .h-100.overflow-hidden(
      style="padding-top: 60px!important;"
    )
      .content.h-100.overflow-auto(
        style="padding-bottom: 70px;"
      )
        .mb-2.mx-3.p-3
          template(
            v-for="(invitation,index) in invitations"
          )
            .row.member.mb-3.p-3.outline-invitation.border-black.custom-shadow(@click="selectTempHandler(invitation.invite_id)")
              .content-invitation
                input.custom_checker(
                  type="checkbox",
                  :id="`checkbox-group-${index}`",
                  name="selectTemps",
                  :checked="isChecked(index)"
                  :class="{ 'hidden-check': isChecked(index) }"
                )
                .input_wrap.d-flex
                  .custom-check-icon.border-black.mr-2
                  .invitation_info.w-100
                    h5 {{ invitation.invite_title }}
                    img.img-fluid.w-100.rounded(:src="invitation.invite_picture_url", style="height:180px;")

          infinite-loading(
            @infinite="infiniteHandler",
            :identifier="infiniteId",
            spinner="bubbles",
            ref="infiniteLoading"
          )
            .cursor-default.mt-3(slot="no-more") 無更多邀請函
            .cursor-default.mt-3(slot="no-results") 無更多邀請函
            .cursor-default.mt-3(slot="error") 發生錯誤，請重整重試一次
    .position-fixed.w-100.modal_footer(
      style="bottom: 0px;height: 70px;z-index: 3;"
    )
      .row.justify-content-center.align-items-center.h-100
        .col-6
          button.btn.btn-block.btn-remind.font-weight-bold.btn-custom(
            type="button",
            @click="invitationsPush()",
            style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;"
          ) 發送
</template>

<script>
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import $ from 'jquery';
import tempTextModel from '@/components/customerModel/tempTextModel.vue';
import tempSendPreviewModel from '@/components/customerModel/tempSendPreviewModel.vue';

// 模板顯示部分
import textInput from '@/components/modalTemplate/messageText/textInput.vue';
import imageMapInput from '@/components/modalTemplate/messageImageMap/imageMapInput.vue';
import carouselInput from '@/components/modalTemplate/messageCarousel/carouselInput.vue';

const _ = require('lodash');

export default {
  name: 'InvitationModel',
  components: {
    InfiniteLoading,
    tempTextModel,
    tempSendPreviewModel,
    textInput,
    imageMapInput,
    carouselInput
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: null
    },
    multicastPush: {
      type: Boolean,
      default: false
    },
    users: {
      type: [Array, Object],
      default: null
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      selectType: 'backend',
      selectTemps: [], // 選擇的模板
      tempModelCSS: {
        top: 0
      }, // 新增訊息模板的 CSS
      infiniteId: +new Date(),
      windowScrollHeight: 0, // 視窗原本位置
    };
  },
  mounted() {
    this.$EventBus.$on('openInvitationModel', () => {
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 初始化
      vm.selectTemps = [];
      vm.$store.commit('sa_invitation/resetInfiniteLoadingData');

      vm.$swal.close();
      vm.openModel();
      vm.infiniteId += 1;
    },
    infiniteHandler($state) {
      const vm = this;
      if (!vm.showModel) return;

      vm.$store.dispatch('sa_invitation/getInvitationsHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    // 選擇模板
    selectTempHandler(id ) {
      const vm = this;
      const selectTemps_key = _.findKey(vm.selectTemps, (val) => val.invite_id === id);
      if (selectTemps_key) {
        vm.selectTemps.splice(selectTemps_key, 1);
      } else {
        const temps_key = _.findKey(vm.invitations, (val) => val.invite_id === id);
        if (temps_key) {
          vm.selectTemps.push(vm.invitations[temps_key]);
        }
      }
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.$emit('closeModelHandler');
      this.showModel = false;
      $('.icon-back').removeClass('d-none');
    },
    changeTypeHandler(type = this.selectType) {
      const vm = this;
      vm.$store.commit('sa_temp/resetInfiniteLoadingData');
      vm.selectType = type;
      vm.infiniteId += 1;
    },
    // 發送邀請函
    async invitationsPush() {
      const vm = this;
      if (vm.selectTemps.length > 5) {
        vm.$swal.fire({
          icon: 'error',
          title: '超出邀請函發送限制，最多五則'
        });
        return;
      }
      vm.$swal.fire({
        title: '模板送出中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      const data = await _.map(vm.selectTemps, (val) => (
        val.invite_id
      ));

      if (vm.multicastPush) {
        const sendData = {
          member_uuid: _.map(vm.users, (val) => val.member_line_uuid || val.line_uuid),
          invite_id: data
        };
        vm.$store.dispatch('sa_chat/invitationsMulticastPushHandler', sendData)
          .then(() => {
            vm.$emit('closeModelHandler');
            vm.closeModel();
            vm.$swal.close();
          });
      } else {
        const sendData = {
          member_uuid: vm.user.member_uuid || vm.user.member_line_uuid,
          invite_id: data
        };

        vm.$store.dispatch('sa_chat/invitationsPushHandler', sendData)
          .then(() => {
            vm.$emit('closeModelHandler');
            vm.closeModel();
            vm.$swal.close();
          });
      }
    },
    // 把視窗移到最頂部
    scrollToTop() {
      return new Promise((resolve, reject) => {
        if ($('#CustomerTempModel').scrollTop() === 0) {
          resolve();
        } else {
          $('#CustomerTempModel').animate({
            scrollTop: 0
          }, 500);
        }
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').addClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
    // 把視窗移到原本位置
    scrollToTarget() {
      const vm = this;
      return new Promise((resolve, reject) => {
        $('#CustomerTempModel').animate({
          scrollTop: vm.windowScrollHeight
        }, 500);
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').removeClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
    isChecked(index) {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.invite_id === vm.invitations[index].invite_id);
      if (key) {
        return true;
      }
      return false;
    },
    order(index) {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.invite_id === vm.invitations[index].invite_id);
      return parseInt(key);
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openInvitationModel');
  },
  computed: {
    ...mapState({
      invitations: (state) => state.sa_invitation.invitations,
      pagination: (state) => state.sa_invitation.pagination
    }),
  }
};
</script>

<style lang="scss" scoped>

  @font-face {
    font-family: "icon";
    src: url("../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.2rem;
    margin-bottom: 4px;
  }

  .iconClose:before {
    content: "\e908";
  }

  .border-black{
    border: 0.2rem solid #000;
  }
  .outline-invitation {
    display: block;
    border-radius: 1rem;
    padding: 1rem;
    cursor: pointer;
  }
  .custom-shadow {
    -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
    box-shadow: 0.2rem 0.2rem 0 #00000033;
  }

  .custom-check-icon {
    width: 2rem;
    height: 2rem;
    background-color: #fff;
    border-radius: 0.4rem;
    margin-right: 1.2rem;
    position: relative;
  }

  .custom_checker:checked ~ .input_wrap .custom-check-icon {
    background-color: #ef4852;
  }

  .custom_checker:checked ~ .input_wrap .custom-check-icon::after {
    display: block;
  }

  .custom-check-icon::after {
    content: '';
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 1.5rem;
    height: 1rem;
    background-image: url(../../assets/images/icon/check-1.png);
    background-size: 1.5rem;
    background-repeat: no-repeat;
  }

  .invitation_info {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  input[type="checkbox"], input[type="radio"] {
    position: absolute;
    width: 1px;
    height: 1px;
    display: none;
    opacity: 0;
  }
</style>
